/**
 * File main.js.
 *
 * Contains the main theme actions/events/process
 */

( function( $ ) {
    new WOW().init();
} )( jQuery );
